import React from "react"
import FooterPageLayout from "src/layouts/footer-page"
import JSONData from "branding/site-metadata.json"

export default function Contact() {
  return (
    <FooterPageLayout title="Contact Us">
          <style>{`
          footer {
          position: relative;
          width: 100%;
          padding: 0;
          margin:0;
          z-index: 1;
          background:#fff;
          border:none;
        }
        footer div {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #e3dedb;
          font-size: 12px;
          margin:0 auto;
          padding: 10px 0;
          list-style:none;
        }
        footer div a {
          margin: 0;
        }
          footer div a:hover {
          text-decoration: none;
          color: #9b928b;
        }
        footer div a:after {
          content: '|';
          padding: 0 8px;
        }

        footer div a:last-child:after {
          content: none;
          padding: 0;
        }
            `}</style>
      <div className="contact-content">
        <div className="contact-intro">
          <p>
          Boldhomescreen.com, the official website of Bold Homescreen
          should you have any additional questions, comments, or compliments, you can also reach us via email at <a href="mailto:contactus@boldhomescreen.com">contactus@boldhomescreen.com</a> You can also send snail mail to the address below. We welcome your feedback!
          </p>
        </div>

        <div className="contact-address">
          <h3>Mailing Address</h3>
          <address>
            Tightrope Interactive, Inc.<br />
            660 4th Street #158<br />
San Francisco, California <br />
94107
          </address>
        </div>

        <div className="about-section">
          <h3>About Us</h3>
          <p>
            Tightrope Interactive creates hand-crafted browser extensions, web sites, creative placements, and more. Our browser extensions span dozens of content verticals and utility products, are highly customizable and backed by our seasoned media team. We strive to improve everything we touch and user experience is top priority.
          </p>
          <p>
            Thanks for your support!
          </p>
          <p className="signature">
            -The boldhomescreen.com Team
          </p>
        </div>
      </div>
    </FooterPageLayout>
  )
}
